import { useState,useEffect, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { ButtonBasic, SelectSubCierreTicket, SelectSubTipoTicket } from '../../components';
import CierreTicketService from '../../services/cierreTicket.service';

const ModalPlantillaCierreTk = ({show, hideModal, item, onGuardar, type}) => {
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [formAll, setFormAll] = useState({
        nombre_ct: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        subTipoArr: {
            texto: [],
            textoErr: 'Los Sub-Tipos son requeridos.',
            estadoErr: false,
            tipo: 'string'
        },
        subCierresArr: {
            texto: [],
            textoErr: 'Los Sub-Cierres son requeridos.',
            estadoErr: false,
            tipo: 'string'
        },
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if((!value || value === '') && input !== 'telefono_c'){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }

    const onSubmit = async() => {
        const form = {createdEmp_mt: 'NUBICOM', subCierresArr: formAll.subCierresArr.texto};
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['nombre_ct','subTipoArr']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(item?.id_ct > 0) {
                form.id = item.id_ct
                await CierreTicketService.update(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }else{
                await CierreTicketService.register(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            setTimeout(() => {
                onChangeForm(item?.nombre_ct,'nombre_ct')
                onChangeForm(item?.arrSubTipo || [],'subTipoArr')
                onChangeForm(item?.arrSubCierre || [],'subCierresArr')
            }, 100);
        }
    }, [item])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: '#000',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: 'gray',
            height: 45,
        }
    }), []);

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.5px);'}}>
            <Box sx={{background: '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_ct > 0 ? 'Editar Cierre de Ticket' : 'Registrar Cierre de Ticket'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{background: 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Titulo:</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.nombre_ct.texto}
                                error={formAll.nombre_ct.estadoErr}
                                helperText={formAll.nombre_ct.estadoErr && formAll.nombre_ct.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'nombre_ct')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Sub-Tipos</Typography>
                            <SelectSubTipoTicket
                                id="id_p"
                                value={formAll.subTipoArr.texto}
                                emp='nubicom'
                                filter='all'
                                onChange={(opt) => onChangeForm(opt.map(op=>(op.value)),'subTipoArr')}
                                isMulti
                            />
                            {(formAll.subTipoArr.estadoErr || formAll.subTipoArr.texto?.length === 0) && (
                                <Typography sx={{color: 'red',fontSize:11,marginLeft:1}}>{formAll.subTipoArr.textoErr}</Typography>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: '#000'}}>Sub-Cierres</Typography>
                            <SelectSubCierreTicket
                                id="id_p"
                                value={formAll.subCierresArr.texto}
                                emp='nubicom'
                                filter='all'
                                onChange={(opt) => onChangeForm(opt.map(op=>(op.value)),'subCierresArr')}
                                isMulti
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{background: 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                        isDisabled={formAll.subTipoArr.texto.length === 0}
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalPlantillaCierreTk